import React, { useState } from "react";
import { Toaster } from "sonner";
import { Helmet } from "react-helmet-async";
import seoRoutes from "@/data/seo-routes.json";

import { useBooking } from "@/contexts/BookingContext";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import ServiceArea from "@/components/landing/ServiceArea";
import FAQ from "@/components/landing/FAQ";
import ContactForm from "@/components/landing/ContactForm";
import Promo from "@/components/landing/Promo";
import ManagedServices from "@/components/landing/ManagedServices";
import BusinessHero from "@/components/landing/BusinessHero";
import BusinessFeatures from "@/components/landing/BusinessFeatures";
import BusinessAssessment from "@/components/landing/BusinessAssessment";
import SocialProof from "@/components/landing/SocialProof";
import EmergencyBanner from "@/components/landing/EmergencyBanner";
import Industries from "@/components/landing/Industries";
import ResponsePromise from "@/components/landing/ResponsePromise";
import TrustBadges from "@/components/landing/TrustBadges";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import LiveStatusBanner from "@/components/landing/LiveStatusBanner";
import LatestGuides from "@/components/landing/LatestGuides";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function Home() {
  const { business, openBooking } = useBooking();
  const [promoCode, setPromoCode] = useState("");
  const [bannerVisible, setBannerVisible] = useState(true);
  const topOffset = bannerVisible ? 40 : 0;

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>{seoRoutes["/"].title}</title>
        <meta name="description" content={seoRoutes["/"].description} />
        <link rel="canonical" href="https://techconnectncllc.services/" />
        <meta property="og:title" content={seoRoutes["/"].title} />
        <meta property="og:description" content={seoRoutes["/"].description} />
        <meta property="og:url" content="https://techconnectncllc.services/" />
        <meta name="twitter:title" content={seoRoutes["/"].title} />
        <meta name="twitter:description" content={seoRoutes["/"].description} />
      </Helmet>
      <Promo onClaim={setPromoCode} onClose={() => setBannerVisible(false)} />
      <Header business={business} topOffset={topOffset} onBook={() => openBooking("")} />
      <main>
        <Hero business={business} topOffset={topOffset} onBook={() => openBooking("")} />
        <LiveStatusBanner />
        <EmergencyBanner />
        <BusinessFeatures onBook={openBooking} />
        <SocialProof />
        <TrustBadges />
        <Services onBook={openBooking} />
        <BusinessHero onBook={openBooking} />
        <BusinessAssessment onBook={openBooking} />
        <Industries />
        <ResponsePromise />
        <HowItWorks />
        <Pricing onBook={openBooking} />
        <ManagedServices onBook={openBooking} />
        <WhyChooseUs />
        <Testimonials />
        <ServiceArea business={business} />
        <FAQ />
        <ContactForm
          business={business}
          promoCode={promoCode}
          onPromoClear={() => setPromoCode("")}
        />
        <LatestGuides />
        <FinalCTA onBook={openBooking} />
      </main>
      <Footer business={business} onBook={() => openBooking("")} />
      <Toaster richColors position="top-right" closeButton />
    </div>
  );
}
